'use client';

import React from 'react';
import useAuthenticatedUser from '@dr-pam/common-components/Hooks/useAuthenticatedUser';

type Props = { children: React.ReactNode };

export default function IfLoggedOut({ children }: Props) {
	const { user } = useAuthenticatedUser();
	if (user) {
		return null;
	}
	return <>{children}</>;
}
